/* eslint no-shadow: ["error", { "allow": ["state"] }] */
const state = {
  fields: [],
};

const getters = {
  fields(state) {
    return state.fields;
  },
};

const mutations = {
  updateField(state, newField) {
    // Find field if it already exists
    const matchingField = state.fields.find(field => field.field_name === newField.field_name);

    if (!matchingField) {
      // Add if doesn't exist
      state.fields.push(newField);
    } else {
      // If exists, then update value
      matchingField.field_value = newField.field_value;
    }
  },
  destroyField(state, newField) {
    // Find index of matching field
    const matchingFieldIndex = state.fields.findIndex(field => field.field_name === newField.field_name);

    if (matchingFieldIndex !== -1) {
      // Remove the field
      state.fields.splice(matchingFieldIndex, 1);
    }
  },
};

const actions = {
  setCreditCardField({ commit }, field) {
    commit('updateField', field);
  },
  destroyCreditCardField({ commit }, field) {
    commit('destroyField', field);
  },
};

/**
 * export module to main store.js
 */
export default {
  state,
  mutations,
  actions,
  getters,
};



// WEBPACK FOOTER //
// ./src/store/modules/creditCardData.js